import React from 'react';
import { useNavigate } from "react-router-dom";
import { FaSync, FaDownload } from 'react-icons/fa';
import { Header, WelcomeTitle, HeaderActions, SyncButton, ExportMenu, ExportOption } from '../styles';
import { Button } from '../../../components/common/Button';

const DashboardHeader = ({ user, perfil, onLogout, syncProps, exportProps, onOpenHistory }) => {
    const navigate = useNavigate();
    
    const formatTime = (ms) => {
        const totalSeconds = Math.floor(ms / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    };

    return (
        <Header>
            {user && <WelcomeTitle>Olá, {perfil.nome}!</WelcomeTitle>}
            <HeaderActions onClick={e => e.stopPropagation()}>
                <div ref={exportProps.exportRef} style={{position: 'relative'}}>
                    <Button variant="secondary" onClick={() => exportProps.setShowExportMenu(!exportProps.showExportMenu)}>
                        <FaDownload /> Exportar
                    </Button>
                    {exportProps.showExportMenu && (
                        <ExportMenu>
                            <ExportOption onClick={() => exportProps.handleExport('metrics')}>
                                📊 Métricas por Página
                            </ExportOption>
                            <ExportOption onClick={() => exportProps.handleExport('posts')}>📝 Lista de Posts Filtrados</ExportOption>
                            <ExportOption onClick={() => exportProps.handleExport('comments')}>💬 Lista de Comentários</ExportOption>
                            <ExportOption onClick={() => exportProps.handleExport('keywords')}>🧠 Análise de Tópicos</ExportOption>
                        </ExportMenu>
                    )}
                </div>
                <SyncButton 
                    onClick={onOpenHistory}
                    disabled={syncProps.isSyncing || syncProps.syncDisabled} 
                    loading={syncProps.isSyncing ? 1 : 0}
                    title={syncProps.syncDisabled ? `Aguarde ${formatTime(syncProps.timeLeft)} para atualizar novamente` : "Abrir opções de sincronização"}
                >
                    <FaSync /> 
                    {syncProps.isSyncing 
                        ? 'Sincronizando...' 
                        : syncProps.syncDisabled 
                            ? `Aguarde ${formatTime(syncProps.timeLeft)}` 
                            : 'Sincronizar Dados'}
                </SyncButton>

                <Button variant="secondary" onClick={() => navigate('/perfil')}>Meu Perfil</Button>
                <Button variant="secondary" onClick={onLogout}>Logout</Button>
            </HeaderActions>
        </Header>
    );
};

export default DashboardHeader;